module.exports = __webpack_public_path__ + "img/29.fixed_mirro.a46e58ec.svg";